import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { DropdownMenuType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';

import { DateRangeDropdown } from '../../../components/date-range-dropdown';
import DateRangeOptions from '../../../components/date-range-dropdown-deprecated/date-range-options';
import { PendingAndInTransitOrdersCard } from './components/pending-orders/pending-and-in-transit-orders';
import { KeyMetricsCard } from './components/key-metrics';
import { ShipmentStatusCard } from './components/shipment-status/shipment-status';
import FulfillmentDashboardContextProvider, { useFulfillmentDashboardContext } from './fulfillment-dashboard-context';

import { messages } from './messages';
import styles from './dashboard-style.module.less';
import React from 'react';

const DASHBOARD_DATE_RANGE_ID = 'fulfillments-dashboard-date-range-dropdown';

export const FulfillmentsDashboard = () => {
  const { setDateRangeCallback, startDateISO, endDateISO, isLoading } = useFulfillmentDashboardContext();

  return (
    <FlexColumn className={styles['page-content']}>
      <FlexRow className={styles['title-row']}>
        <Text textType={TextType.H1} value={messages.overview} />
        <div className={styles['date-range-wrapper']}>
          <label htmlFor={DASHBOARD_DATE_RANGE_ID}>
            <Text textType={TextType.Label} value={messages.selectDateRangeLabel} />
          </label>
          <DateRangeDropdown
            className={styles['date-range-dropdown']}
            dateRangeOptions={DateRangeOptions}
            dropdownMenuType={DropdownMenuType.ComboBox}
            endDate={endDateISO}
            id={DASHBOARD_DATE_RANGE_ID}
            onDateRangeUpdated={setDateRangeCallback}
            startDate={startDateISO}
          />
        </div>
      </FlexRow>
      {isLoading ? (
        <FlexRow className={styles['loading-indicator-wrapper']}>
          <LoadingIndicator className={styles['loading-indicator']} />
        </FlexRow>
      ) : (
        <>
          <FlexRow className={styles['key-metrics-wrapper']}>
            <KeyMetricsCard />
          </FlexRow>
          <FlexRow className={styles['status-and-order-row']}>
            <ShipmentStatusCard />
            <PendingAndInTransitOrdersCard />
          </FlexRow>
        </>
      )}
    </FlexColumn>
  );
};

export const ContextWrappedDashboard = () => (
  <FulfillmentDashboardContextProvider>
    <FulfillmentsDashboard />
  </FulfillmentDashboardContextProvider>
);
